import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useCheckTokenValidQuery } from "../../../hooks/queries/useAuthQueries";
import { extractAxiosErrorMessage } from "../../../services/utils/errorUtils";
import { CustomLoadingOverlay } from "../../ui/CustomLoadingOverlay/CustomLoadingOverLay";

const TokenValidatorGuard = ({ children, errorRoutes, fallbackRoute }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const { isLoading, isSuccess, isError, error } = useCheckTokenValidQuery(token);

  useEffect(() => {
    if (!token) {
      navigate(fallbackRoute.to, { replace: true, state: { bannerReason: fallbackRoute.reason } });
      return;
    }
    if (isError) {
      const msg = extractAxiosErrorMessage(error).toLowerCase();
      const { to, reason } = errorRoutes[msg] ?? fallbackRoute;
      navigate(to, { replace: true, state: { bannerReason: reason } });
    }
  }, [token, isError, error, navigate, errorRoutes, fallbackRoute]);

  if (!token || isError) return null;

  if (isLoading) {
    return (
      <div className="fixed inset-0">
        <CustomLoadingOverlay
          visible
          overlayProps={{ radius: "sm", blur: 2, backgroundOpacity: 0.6 }}
          loaderProps={{ color: "primary", type: "bars" }}
        />
      </div>
    );
  }

  if (isSuccess) {
    return children;
  }

  return null;
};

export default TokenValidatorGuard;
